var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOffline = function SvgOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    style: {
      enableBackground: "new 0 0 21 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.5c-.3-.4-1-.5-1.4-.1-.4.3-.5 1-.1 1.4l11.4 13.3c.4.4 1 .5 1.4.1.4-.4.5-1 .1-1.4L4.5 1.5zM1.5 4.7c.4-.3 1-.2 1.3.2l8.9 10.3c.3.4.3 1 0 1.4l-.9 1c-.4.5-1.2.5-1.6 0L.2 7c-.4-.4-.3-1 .1-1.4l1.2-.9zM16.3 11.1c-.4.5-1.2.5-1.6 0L8.3 3.6C7.8 3 8.1 2.1 9 2c3.8-.3 7.7.9 10.7 3.6.4.4.4 1 .1 1.4l-3.5 4.1z"
  })));
};
export default SvgOffline;